import { ReleaseNoteArgs, ReleaseNotes, getReleaseNoteback } from '../assets/ts/data/release-note'
import useServerData from './use-server-data'

function useReleaseNotes(fetchArgs, waitOnParentDependency = false) {
  const {
    data: releaseNotes,
    error: releaseNoteError,
    fetchData: fetchReleaseNotes,
    isLoading: releaseNoteIsLoading,
  } = useServerData<ReleaseNotes, ReleaseNoteArgs>(
    getReleaseNoteback,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchReleaseNotes,
    releaseNoteError,
    releaseNoteIsLoading,
    releaseNotes,
  }
}

export default useReleaseNotes
